const DEFAULT_MEETING_BASE_URL = 'https://live.ubunifucollege.com/interviews';
export const INTERVIEW_JOIN_EARLY_WINDOW_MINUTES = 2;

const stripTrailingSlash = (value) => String(value || '').replace(/\/+$/, '');
const toDate = (value) => {
  if (!value) return null;
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return date;
};

export const getInterviewMeetingBaseUrl = () => {
  const configuredBase = process.env.REACT_APP_INTERVIEW_MEETING_BASE_URL;
  if (configuredBase) {
    return stripTrailingSlash(configuredBase);
  }

  return DEFAULT_MEETING_BASE_URL;
};

export const buildInterviewMeetingLink = (meetingId) => (
  `${getInterviewMeetingBaseUrl()}/${encodeURIComponent(String(meetingId || '').trim())}`
);

export const getInterviewJoinAvailability = (scheduledFor, now = new Date()) => {
  const scheduledStart = toDate(scheduledFor);
  if (!scheduledStart) {
    return {
      scheduledStart: null,
      availableAt: null,
      canJoin: true,
      remainingMs: 0,
      isScheduled: false
    };
  }

  const availableAt = new Date(scheduledStart.getTime() - (INTERVIEW_JOIN_EARLY_WINDOW_MINUTES * 60 * 1000));
  const remainingMs = Math.max(0, availableAt.getTime() - now.getTime());

  return {
    scheduledStart,
    availableAt,
    canJoin: remainingMs <= 0,
    remainingMs,
    isScheduled: true
  };
};

const formatCalendarDate = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';

  return date
    .toISOString()
    .replace(/[-:]/g, '')
    .replace(/\.\d{3}Z$/, 'Z');
};

export const buildGoogleCalendarLink = ({ title, start, end, details, location }) => {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title || 'Interview',
    dates: `${formatCalendarDate(start)}/${formatCalendarDate(end)}`,
    details: details || '',
    location: location || '',
  });

  return `https://calendar.google.com/calendar/render?${params.toString()}`;
};

export const buildOutlookCalendarLink = ({ title, start, end, details, location }) => {
  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: title || 'Interview',
    startdt: new Date(start).toISOString(),
    enddt: new Date(end).toISOString(),
    body: details || '',
    location: location || '',
  });

  return `https://outlook.live.com/calendar/0/deeplink/compose?${params.toString()}`;
};
